import React, {useState} from 'react';
import { Box, Button, Container, TextField, Typography } from '@mui/material';
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { Email } from '@mui/icons-material';
import { emailVerificationSchema } from '../../services/validator';
import useEncryption from '../../services/useEncryption';
import useToast from '../../helpers/useToast';
import { forgotPasswordApi } from '../../api/authApi/authApi';
import sidebanner from "../../assets/images/authimgs/bannerside.svg"
import "./forgetpassword.css";
import Loader from '../../helpers/loader/Loader';

const ForgetPassword = () => {
  const [verificationSent, setVerificationSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const { encryptData } = useEncryption();
  const toastOptions = useToast();

  const initialValues = {
    email: '',
  };

  const validationSchema = emailVerificationSchema;

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      const data = encryptData(values);
      const response = await forgotPasswordApi(data);
      setLoading(false);
      setVerificationSent(true);
      toast.success(response.data.message,toastOptions); 
  } catch (error) {
      toast.error(error.response.data.message, toastOptions);
  }  
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });


  return (
    <main className="authForms">
      <Loader loading={loading} />

      <div className="row">
        <div className="col-lg-4 col-sm-12">
          <img className="bannerImg" src={sidebanner} alt="banner" />
        </div>
        <div className="col-lg-8 col-sm-12">
        <Box  className="auth-page">
          
          
        <div className="authconatiner">
        <Box className="auth-form">
        <Typography variant="h4" align="center" gutterBottom sx={{color: "#2192E5 "}}>
             Forgot Password ?

            </Typography>
            {/* <Email sx={{ fontSize: 20, verticalAlign: "middle", marginLeft: "45%", width: "50px", height: "50px", color: "#F78220", marginTop: "20px", marginBottom: "20px"}}/> */}
                {verificationSent ? (
                  <Box>
                    <Typography variant="body2" align="center" sx={{ color: "#D29705", marginTop: 2 }}>
                      If this account exists, an email will be sent for verification.
                    </Typography>  
                </Box>
                  
                ):(
                  <form onSubmit={formik.handleSubmit} className='mt-4'>
                  <Typography variant="body1" align="center" gutterBottom sx={{color: "#8E8C89"}}>
                    Please enter your email address to receive a verification link.
                  </Typography>
                  <Box className="input-field-section" sx={{ height: "80px", marginBottom: "0px"}}>
                    <TextField
                      fullWidth
                      id="email"
                      name="email"
                      label="Email"
                      type="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.email && Boolean(formik.errors.email)}
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Box>
                    <Button
                    className="btnMain"
                      type="submit"
                      variant="contained"
                      color="success"
                      fullWidth
                      sx={{ mt: 2 }}
                    >
                      Send Verification Link
                    </Button>
                    <Box mt={2} display="flex" justifyContent="right">
                      <Link to="/" className="forgotPasswordLink">
                        Go to Login 
                      </Link>
                    </Box>
                  </form>
                )}
        </Box>

        </div>

      </Box>
        </div>
      </div>
      </main>


   
  );
};

export default ForgetPassword;
